import { uid } from '../../../utils/random';

export function request(userId, bet) {
    bet = {
        ...bet,
        uid: bet.type === 'SGL' ? bet.legs[0] : uid()
    };
    console.log('=== bet in add-bet ===', bet);

    return {
        type: 'BETSLIP_ADD_BET',
        userId,
        bet
    };
}
